<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入风格名称进行搜索"
        v-model="body.keyword"
        clearable
        class="input-with-select dk_input"/>
      <el-button
        type="primary"
        @click="search()">
        搜索
      </el-button>
      <el-button @click="event().clearKeyword()">重置</el-button>
      <div>
        <el-button
          type="primary"
          @click="event().toAddStyleClick()">
          新建风格
        </el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="priority"
        label="排序"/>
      <el-table-column
        prop="name"
        label="风格"/>
      <el-table-column
        fixed="right"
        label="操作"
        width="330">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toDetailClick(scope.row.uuid)">
            删除
          </el-button>
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toEditStyleClick(scope.row.uuid)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>

    <!-- 确认删除 -->
    <el-dialog
      width="480px"
      title="提示"
      :visible.sync="deleteStyleDialog">
      <div>确认删除数据，是否继续 ?</div>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="deleteStyleDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToDeleteClick()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新增风格 -->
    <el-dialog
      width="480px"
      title="新增风格"
      :visible.sync="toAddStyleDialog">
      <el-form
        :model="toAddBody"
        ref="ruleForm3"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          label="风格名称："
          prop="name">
          <el-input
            placeholder="请输入风格名称"
            class="dk-input"
            v-model="toAddBody.name"/>
        </el-form-item>
        <el-form-item
          label="排序："
          prop="name">
        <el-input
          placeholder="请输排序"
          class="dk-input"
          v-model="toAddBody.priority"/>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="toAddStyleDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToAddStyleClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>

  </el-main>
</template>

<script>
import { getStyleList, deleteStyle, addStyle, getStyleDetail, editStyle } from '../../api/case'
import { imgDomain } from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { setId } from '../../jslib/set-id'

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      body: {
        keyword: '',
        page_index: 1,
        page_size: 20,
      },
      total: 0,
      tableData: [
        {},
      ],
      deleteStyleDialog: false,
      deleteUuid: '',
      toAddStyleDialog: false,
      toAddBody: {}
    };
  },

  components: {
  },
  created() {
    this.network().getStyleList()
  },
  methods: {
    handleCurrentChange() {
      this.network().getStyleList()
    },
    search() {
      this.network().getStyleList()
    },
    event() {
      return {
        clearKeyword: () => {
          this.body.keyword = ''
        },
        toAddOrEditClick: (uuid) => {
          this.$router.push({ path: 'brand-add', query: { uuid } })
        },
        toDetailClick: (uuid) => {
          this.deleteStyleDialog = true
          this.deleteUuid = uuid
        },
        onSureToDeleteClick: () => {
          this.network().deleteStyle()
        },
        toAddStyleClick: () => {
          this.toAddBody = {}
          this.toAddBody.uuid = ''
          this.toAddStyleDialog = true
        },
        toEditStyleClick: (uuid) => {
          this.toAddBody = {}
          this.toAddBody.uuid = uuid
          this.network().getStyleDetail()
          this.toAddStyleDialog = true
        },
        onSureToAddStyleClick: () => {
          this.network().addStyle()
        },
      }
    },
    network() {
      return {
        getStyleList: async () => {
          const { status, data } = await getStyleList(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.tableData = data.data
          this.total = data.total
        },
        deleteStyle: async () => {
          const { status } = await deleteStyle({'uuid': this.deleteUuid})
          if (status !== 200) return
          this.deleteStyleDialog = false
          this.$notify({
            title: '删除成功',
            message: '删除成功',
            type: 'success',
          });
          this.network().getStyleList()
        },
        addStyle: async () => {
          let status = {}
          if (this.toAddBody.uuid != '') {
            status = await editStyle(this.toAddBody)
          } else {
            status = await addStyle(this.toAddBody)
          }
          if (status.status !== 200) return
          this.toAddStyleDialog = false
          if (this.toAddBody.uuid != '') {
            this.$notify({
              title: '修改成功',
              message: '修改成功',
              type: 'success',
            });
          } else {
            this.$notify({
              title: '添加成功',
              message: '添加成功',
              type: 'success',
            });
          }
          this.network().getStyleList()
        },
        getStyleDetail: async () => {
          const { status, data } = await getStyleDetail({'uuid': this.toAddBody.uuid})
          if (status !== 200) return
          this.toAddBody = data
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/case/manner-list.vue